const fbInit = () => {
  return FB.init({
    appId: process.env.API_FACEBOOK_ID,
    autoLogAppEvents: true,
    xfbml: true,
    version: 'v4.0',
  });
};

export const sendInMessenger = (sharedLink: string) => {
  fbInit();
  return FB.ui(
    {
      method: 'send',
      link: sharedLink,
    },
    (response: any) => {
      if (response && !response.error_message) {
        // eslint-disable-next-line no-console
        console.log('Posting completed.');
      } else {
        console.error('Error while posting.');
      }
    },
  );
};

export const sharedInFeed = (sharedLink: string) => {
  fbInit();
  return FB.ui(
    {
      display: 'popup',
      method: 'share',
      href: sharedLink,
    },
    (response: any) => {
      if (response && !response.error_message) {
        // eslint-disable-next-line no-console
        console.log('Posting completed.');
      } else {
        console.error('Error while posting.');
      }
    },
  );
};
